import '../../css/CallToRemove.css'

const CallToRemove = () => 
  <p className="CallToRemove"><em>Cluster sorted? <a href="https://forms.gle/NvxD1Zf1HDFrQu1F8">Let us know</a> so we can remove you from our database [V2.0.2]</em></p>
export default CallToRemove;